import React from "react";
import { Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  // ReactNode (no solo string) — algunas páginas pasan JSX al tooltip con
  // varios párrafos / negritas / `<code>` (ej. /finanzas-aseador). Si te
  // basta texto plano, sigue funcionando.
  helpText?: React.ReactNode;
  extra?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  helpText,
  extra,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.titleRow}>
        <div style={styles.titleGroup}>
          <Title level={3} style={styles.title}>
            {title}
          </Title>
          {helpText && (
            <Tooltip title={helpText} placement="right">
              <InfoCircleOutlined style={styles.infoIcon} />
            </Tooltip>
          )}
        </div>
        {extra && <div style={styles.extra}>{extra}</div>}
      </div>
      {subtitle && (
        <Text type="secondary" style={styles.subtitle}>
          {subtitle}
        </Text>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    marginTop: 8,
    marginBottom: 16,
    background: "var(--color-surface)",
    padding: "12px 16px",
    borderRadius: "var(--radius-lg)",
    boxShadow: "var(--shadow-card)",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  titleGroup: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    color: "var(--text-primary)",
  },
  infoIcon: {
    fontSize: 16,
    color: "var(--primary-color)",
    cursor: "help",
    opacity: 0.6,
  },
  subtitle: {
    display: "block",
    marginTop: 4,
    fontSize: "var(--font-size-sm)",
  },
  extra: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
};

export default PageHeader;
